import { useOutletContext } from "@remix-run/react";
import { CardList } from "~/shared";
import type { IMedia } from "~/types";
import { FullbackScreen } from "~/shared";

export default function Index() {
  const { data } = useOutletContext<{
    data: Array<IMedia>;
    showPendingSpinner: boolean;
    isFetchingNextPage: boolean;
    hasNextPage: boolean;
  }>();

  if ((data && !data.length) || !data)
    return (
      <FullbackScreen
        subtitle="Versuche es mit einem anderen Suchbegriff oder verwende weniger Filter. Manchmal hilft auch die Suche in einem anderen Bundesland."
        title="Leider konnten wir kein Medium finden."
      />
    );
  return <CardList cards={data} />;
}
